import { atom } from 'jotai'

export const _parentIsometry = atom({
  frames       : {},
  percent      : {},
  status       : {},
  activeframe  : {},
  svgdimensions: {},
  activescale  : {},
  config       : {},
  snapindex    : {},
  imageindex   : {},
  showoverlay  : {},
  mode         : {},
  toggle       : {},
  tiny         : [],
  overlays     : []
})